import { EMAIL_CONTACT } from "../../shared/consts";

export const schoolAddress = ['Zishumbe', 'Masvingo', 'Zimbabwe'];

// Administration lines. Add or remove an entry here and the contact page follows.
export const administrationContacts = [
  { id: 1, label: 'Admissions Office', tel: '+263 77 461 9684' },
  { id: 2, label: 'Administration', tel: '+263 78 499 4507' },
  { id: 3, label: 'Accounts and Enquiries', tel: '+263 77 962 0154' }
];

export const emailContact = EMAIL_CONTACT;

// Families applying from outside Zimbabwe. Numbers above are reachable on
// WhatsApp, so international enquiries are handled on the same lines.
export const internationalNote = 'We welcome families based in Zimbabwe, South Africa, Botswana and the ' +
  'United Kingdom. All of the numbers above are available on WhatsApp, so international parents can reach ' +
  'the Administration directly at no extra cost.';
